import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ADPResourceService } from 'digital-core';
import { AppConstants } from 'src/app/core/constants';
import { AriaLabelDirective, GtmClickDirective } from 'src/app/shared/directives';
import { AdpLabelDynamicComponent } from '../adp-label-dynamic';
import { PlanRenewalService } from './plan-renewal.service';

@Component({
  selector: 'app-plan-renewal-notice',
  imports: [MatIcon, MatButtonModule, GtmClickDirective, AriaLabelDirective, AdpLabelDynamicComponent],
  templateUrl: './plan-renewal-notice.component.html',
  styleUrl: './plan-renewal-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanRenewalNoticeComponent {
  // Every state this card can render — copy, icon, colors and button keys — is resolved by the
  // service from the {Context}_Renewal_Notice_Thresholds CMS descriptors, so there is no
  // per-state branching here.
  protected readonly renewal = inject(PlanRenewalService);
  private resourceService = inject(ADPResourceService);
  private router = inject(Router);

  protected getResourceViewLabel(key: string): string | null {
    const label = this.resourceService.getViewLabelObject(key);
    return label ? this.resourceService.transformContentData(label.Value) : null;
  }

  protected onRenewClick(): void {
    this.router.navigate(['/renew'], { state: { [AppConstants.ROUTE_NAV_STATE.PlanRenewalFromRenewClick]: true } });
  }
}
